import React from "react";
import { classNames } from "../../utils/helpers";
import Icon from "../Icon";
import PropTypes from "prop-types";
const MultiBadgeSelector = (props) => {
  const { onChange, fieldsInfo } = props;
  return (
    <div className="w-full py-2">
      <div className="flex flex-wrap gap-2">
        {fieldsInfo && fieldsInfo.length > 0 ? (
          fieldsInfo.map((item, index) => (
            <button
              key={index}
              type="button"
              onClick={() => onChange(item.vc_keycolumn)}
              className={classNames(
                "text-gray-800 text-sm py-1.5 px-2 border rounded-lg capitalize transition-colors duration-200 hover:bg-gray-300"
              )}
            >
              {item.vc_keycolumn}
            </button>
          ))
        ) : (
          <div className="text-yellow-800 text-sm font-semibold flex items-center">
            <Icon icon="warning" className="text-yellow-800 px-1" />
            No se han configurado plantillas
          </div>
        )}
      </div>
    </div>
  );
};

MultiBadgeSelector.propTypes = {
  onChange: PropTypes.func,
  fieldsInfo: PropTypes.array,
};

export default MultiBadgeSelector;
